import {PublicPageStyle} from "../../constants/styles";
import PublicTemplate from "../publics/PublicTemplate";
import styled from "styled-components";
import {Button, Input, Pagination, Table} from "antd";
import {useEffect, useState} from "react";
import axios from "axios";

const LogPage = () => {
    const [eplusData, setEplusData] = useState<null | {
        totalPage: number;
        totalElement: number;
        currentPage: number;
        items: Array<{
            id: string;
            seq: number;
            val: number;
            rv: number;
            ri: number;
            sv: number;
            si: number;
            tv: number;
            ti: number;
            fire: number;
            temperature: number;
            humidity: number;
            createAt: string;
        }>;
    }>(null);
    const [waterData, setWaterData] = useState<null | {
        totalPage: number;
        totalElement: number;
        currentPage: number;
        items: Array<{
            id: string;
            seq: number;
            channelOneValue: number;
            channelTwoValue: number;
            rawValue: string;
            createAt: string;
        }>;
    }>(null);
    const [ePage, setEPage] = useState(1);
    const [wPage, setWPage] = useState(1);
    const [searchE, setSearchE] = useState("");
    const [searchW, setSearchW] = useState("");

    const getEplusData = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL2}/terra/log?page=${ePage - 1}&id=${searchE}`);
            if (res.data) {
                console.log(res.data);
                setEplusData(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getWaterData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL2}/waterLevel/log?page=${wPage - 1}&id=${searchW}`,
            );
            if (res.data) {
                console.log(res.data);
                setWaterData(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getEplusData();
    }, [ePage]);
    useEffect(() => {
        getWaterData();
    }, [wPage]);

    return (
        <PublicPageStyle>
            <PublicTemplate align={"flex-end"}>
                <Container>
                    <TableTitle>
                        <Label>EPLUS</Label> <Button onClick={() => getEplusData()}>새로고침</Button>
                        <StyledInput
                            value={searchE}
                            allowClear
                            onChange={(e) => setSearchE(e.target.value)}
                            placeholder={"ID 검색 (Enter)"}
                            onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                    getEplusData();
                                }
                            }}
                        />
                    </TableTitle>
                    <Table
                        pagination={false}
                        dataSource={eplusData ? eplusData.items : []}
                        columns={[
                            {
                                title: "id",
                                dataIndex: "id",
                            },
                            {
                                title: "seq",
                                dataIndex: "seq",
                            },
                            {
                                title: "val",
                                dataIndex: "val",
                            },
                            {
                                title: "rv",
                                dataIndex: "rv",
                            },
                            {
                                title: "ri",
                                dataIndex: "ri",
                            },
                            {
                                title: "sv",
                                dataIndex: "sv",
                            },
                            {
                                title: "si",
                                dataIndex: "si",
                            },
                            {
                                title: "tv",
                                dataIndex: "tv",
                            },
                            {
                                title: "ti",
                                dataIndex: "ti",
                            },
                            {
                                title: "temperature",
                                dataIndex: "temperature",
                            },
                            {
                                title: "humidity",
                                dataIndex: "humidity",
                            },
                            {
                                title: "cdate",
                                dataIndex: "createAt",
                            },
                        ]}
                    />
                    <br />
                    <Pagination
                        align={"center"}
                        current={ePage}
                        total={eplusData ? (eplusData.totalElement ?? 1) : 1}
                        pageSize={20}
                        showSizeChanger={false}
                        onChange={(page) => setEPage(page)}
                    />
                    <TableTitle>
                        <Label>WATER LEVEL</Label> <Button onClick={() => getWaterData()}>새로고침</Button>
                        <StyledInput
                            value={searchW}
                            onChange={(e) => setSearchW(e.target.value)}
                            placeholder={"ID 검색"}
                            onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                    getWaterData();
                                }
                            }}
                        />
                    </TableTitle>
                    <Table
                        pagination={false}
                        dataSource={waterData ? waterData.items : []}
                        columns={[
                            {
                                title: "id",
                                dataIndex: "id",
                            },
                            {
                                title: "seq",
                                dataIndex: "seq",
                            },
                            {
                                title: "채널 1 (%)",
                                dataIndex: "channelOneValue",
                            },
                            {
                                title: "채널 2 (%)",
                                dataIndex: "channelTwoValue",
                            },
                            {
                                title: "원본데이터",
                                dataIndex: "rawValue",
                            },
                            {
                                title: "cdate",
                                dataIndex: "createdAt",
                            },
                        ]}
                    />
                    <br />
                    <Pagination
                        align={"center"}
                        current={wPage}
                        total={waterData ? (waterData.totalElement ?? 1) : 1}
                        pageSize={20}
                        showSizeChanger={false}
                        onChange={(page) => setWPage(page)}
                    />
                    <Padding />
                </Container>
            </PublicTemplate>
        </PublicPageStyle>
    );
};

export {LogPage};

const Container = styled.div`
    width: 100%;
    align-content: flex-start;
    margin-bottom: 300px;
`;
const Padding = styled.div`
    height: 200px;
`;

const TableTitle = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
`;

const StyledInput = styled(Input)`
    width: 400px;
    margin-left: 12px;
`;

const Label = styled.label`
    font-size: 24px;
    font-weight: 600;
    margin-right: 18px;
`;
